const initBlock = function( $block ) {
	function faqItems() {
		const $items = $block.find( '.faq-item' );
		if ( !$items.length ) { return false; }
		$items.each( function( i, item ) {
			const $item = $( item );
			const $question = $item.find( '.faq-item__question' );
			const $answer = $item.find( '.faq-item__answer' );
			$question.on( 'click', function( e ) {
				if ( $( e.target ).closest( '.faq-item__answer' ).length === 0 ) {
					e.preventDefault();

					if ( !$item.hasClass( 'is-opened' ) ) {
						$items.removeClass( 'is-opened' );
						$items.find( '.faq-item__answer' ).stop().slideUp( 300 );
					}

					$item.toggleClass( 'is-opened' );
					$answer.stop().slideToggle( 300 );
				}
			} );
		} );
	};
	faqItems();
};

app.loadBlock( initBlock, 'section-faq', '.section-faq' );

if ( module.hot ) {
	module.hot.accept();
}
